import { connect } from 'react-redux';
import { Link as v4Link } from 'react-router-dom';
import { AppLayoutContainer } from '@zg-rentals/zrm-header-navigation';

const hostName = typeof window !== 'undefined' && window !== null ? window.location.host : 'www.zillow.com';

const PaymentsHeaderNav = (props: any): JSX.Element =>
  props.userModel && (
    <AppLayoutContainer
      altLogo={!props.userModel.isRocketshipCustomerOnly}
      reactRouterLink={v4Link}
      host={hostName}
      useRelativePaths={false}
      {...props}
    />
  );

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  userModel: state.user,
});

export { PaymentsHeaderNav };
export default connect(mapStateToProps)(PaymentsHeaderNav);
